import { render, staticRenderFns } from "./QualificationReviewQueue.vue?vue&type=template&id=5963f964&"
import script from "./QualificationReviewQueue.vue?vue&type=script&lang=js&"
export * from "./QualificationReviewQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports